"use client";

export function LinksPageSkeleton() {
  return (
    <div className="min-h-screen bg-background">
      <div className="public-width py-12">
        <div className="animate-pulse space-y-8">
          {/* Header skeleton */}
          <div className="space-y-2">
            <div className="h-8 bg-muted rounded w-32" />
            <div className="h-4 bg-muted rounded w-64" />
          </div>
          
          {/* Content skeleton */}
          {[1, 2, 3].map(i => (
            <div key={i} className="space-y-3 pt-8 border-t border-border first:border-0 first:pt-0">
              <div className="h-7 bg-muted rounded w-48" />
              <div className="space-y-2">
                <div className="h-4 bg-muted rounded w-full" />
                <div className="h-4 bg-muted rounded w-3/4" />
                <div className="h-4 bg-muted rounded w-5/6" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
